import React from "react";
import classNames from "classnames";
import { WebAppContext } from "./WAContainer";

export const WASidenav: React.FC<{}> = ({ children }) => {
  let state = WebAppContext.useContainer();
  return (
    <aside className={classNames("wa-sidenav", { show: state.open })}>
      {children}
    </aside>
  );
};
